import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { CategoryFieldType, CategoryFieldTypeEnum, FieldValueType } from 'types';
import { ToEnglish } from 'scripts';

export default function CategoryFieldValuesComp(props: {
    categoryFields?: CategoryFieldType<'detail'>[];
    initialData?: FieldValueType<'detail'>[];
}) {
    if (!props.categoryFields || props.categoryFields.length === 0) return null;
    return (
        <Row gutter={24}>
            {props.categoryFields
                .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                ?.map((item) => {
                    const initialValue = props.initialData?.find((i) => i.category_field.id === item.id);
                    return (
                        <Col key={item.id} lg={{ span: 12 }} md={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item
                                label={item.title + ' ' + (item.unit?.length ? `(${item.unit})` : ' ')}
                                name={['category_fields_values', `${item.id}`]}
                                rules={
                                    item.required
                                        ? [{ required: true, message: 'وارد کردن این فیلد اجباری ست' }]
                                        : undefined
                                }
                                extra={
                                    item.type === CategoryFieldTypeEnum.number
                                        ? 'لطفا با کیبورد انگلیسی مقدار خود را وارد کنید'
                                        : undefined
                                }
                                initialValue={
                                    item.type === CategoryFieldTypeEnum.number
                                        ? initialValue?.value_number
                                        : item.type === CategoryFieldTypeEnum.fieldOptions
                                          ? initialValue?.option?.id
                                          : initialValue?.value
                                }
                            >
                                {item.type === CategoryFieldTypeEnum.boolean ? (
                                    <Select
                                        allowClear
                                        options={[
                                            { label: 'بله', value: '1' },
                                            { label: 'خیر', value: '0' },
                                        ]}
                                    />
                                ) : item.type === CategoryFieldTypeEnum.number ? (
                                    <InputNumber
                                        onKeyDown={(e) => {
                                            const regex = /^[0-9\u06F0-\u06F9,]+$/;
                                            if (!regex.test(e.key) && e.key !== 'Backspace') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                        inputMode="decimal"
                                        formatter={(value) => {
                                            const valueString = ToEnglish(value?.toString() ?? '').replace(/\D/g, '');
                                            const valueNumber = Number(valueString);
                                            if (valueString?.length && valueNumber) {
                                                return valueNumber?.toLocaleString('en-US');
                                            } else return value?.toString() ?? '';
                                        }}
                                        parser={(value) => {
                                            const newValue = ToEnglish(value?.toString() ?? '').replace(/\D/g, '');
                                            return newValue?.length ? Number(newValue) : '';
                                        }}
                                    />
                                ) : item.type === CategoryFieldTypeEnum.text ? (
                                    <Input />
                                ) : (
                                    <Select
                                        allowClear
                                        options={item.field_options?.map((i) => ({ label: i.title, value: i.id }))}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    );
                })}
        </Row>
    );
}
